import { render, staticRenderFns } from "./GoogleAd.vue?vue&type=template&id=7c4ae64d&"
import script from "./GoogleAd.vue?vue&type=script&lang=ts&"
export * from "./GoogleAd.vue?vue&type=script&lang=ts&"
import style0 from "./GoogleAd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports